/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */

import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { LabCategoryApi } from '../api/labcategory.api';
import { switchMap, map } from 'rxjs/operators';
import { LabCategoryData, LabCategory } from '../../../interfaces/masters/labcategory';

@Injectable()
export class LabCategoryService extends LabCategoryData {

  constructor(private api: LabCategoryApi) {
    super();
  }


  list(): Observable<LabCategory[]> {
    return this.api.list();
  }

  getById(url:string): Observable<LabCategory>{
      return this.api.getById(url);
  }
  
  // get sub category list by RAJA
  subList(url:string): Observable<LabCategory[]>{
      return this.api.subList(url);
  }

  create(url: string, data:LabCategory): Observable<LabCategory> {
    return this.api.add(url,data);
  }

  update(url: string, data:LabCategory): Observable<LabCategory> {
    return this.api.update(url,data);
  }

  

  delete(url: string): Observable<boolean> {
    return this.api.delete(url);
  }
}
